import styled from 'styled-components'

export const RegInput = styled.p`
  position: relative;
  font-family: ${(props) => props.theme.regFont};
  color: ${(props) => props.theme.regColour};
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 24px;
  line-height: 48px;
  margin: 10px 0 0 0;
  text-align: center;
  border: 1px solid ${(props) => props.theme.inputBorderColour};
  border-radius: ${(props) => props.theme.formControlBorderRadius};
  height: 50px;
  box-sizing: border-box;
  padding-left: 28px;
  @media (min-width: 768px) {
    font-size: 40px;
    line-height: 58px;
    height: 60px;
  }
`

export const GBIcon = styled.span`
  position: absolute;
  left: 0px;
  top: 0px;
  width: 30px;
  height: 48px;
  z-index: 2;
  font-family: 'Purista', sans-serif;
  font-weight: 600;
  text-align: center;
  letter-spacing: 1px;
  line-height: 50px;
  color: ${(props) => props.theme.GbIcon};
  box-sizing: border-box;
  font-size: 12px;
  border-right: 1px solid ${(props) => props.theme.inputBorderColour};
  @media (min-width: 768px) {
    width: 50px;
    height: 58px;
    font-size: 20px;
    line-height: 58px;
  }
`
